/**
 * Stavke bocnog menija POS web aplikacije, za izbor u panelu (ADR-051).
 *
 * Panel ne moze da uveze `src/features/navigation/nav-items.ts` (drugi build),
 * pa je spisak prepisan. Da se ne razidju, cuva ga test
 * `src/features/navigation/__tests__/admin-nav-catalog.test.ts`: svaka stavka
 * menija mora biti ovde, i nista vise.
 *
 * `legal` (pravni dokumenti) namerno nije u spisku - uvek je dostupan, jer
 * ono na sta je korisnik pristao mora moci da procita.
 */
export type NavCatalogItem = { key: string; label: string; group: string };

export const NAV_CATALOG: NavCatalogItem[] = [
  { key: 'dashboard', label: 'Kontrolna tabla', group: 'Pregled' },
  { key: 'pos-sale', label: 'Prodaja', group: 'Prodaja' },
  { key: 'old-fiscalization', label: 'Stara fiskalizacija', group: 'Prodaja' },
  { key: 'sale-drafts', label: 'Sačuvani računi', group: 'Prodaja' },
  { key: 'invoices', label: 'Računi', group: 'Prodaja' },
  { key: 'invoices-advance', label: 'Avansni računi', group: 'Prodaja' },
  { key: 'report-revenue', label: 'Evidencija prometa', group: 'Izveštaji' },
  { key: 'report-daily', label: 'Dnevni izveštaj', group: 'Izveštaji' },
  { key: 'report-monthly', label: 'Mesečni izveštaj', group: 'Izveštaji' },
  { key: 'report-kep', label: 'KEP knjiga', group: 'Izveštaji' },
  { key: 'report-shifts', label: 'Izveštaj po smenama', group: 'Izveštaji' },
  { key: 'report-by-article', label: 'Prodaja po artiklu', group: 'Izveštaji' },
  { key: 'report-by-payment', label: 'Prodaja po načinu plaćanja', group: 'Izveštaji' },
  { key: 'report-by-table', label: 'Prodaja po stolu', group: 'Izveštaji' },
  { key: 'report-by-waiter', label: 'Prodaja po kasiru', group: 'Izveštaji' },
  { key: 'report-taxes', label: 'Poreski izveštaji', group: 'Izveštaji' },
  { key: 'report-dpu-services', label: 'DPU - Promet usluga', group: 'Izveštaji' },
  { key: 'report-customers', label: 'Izveštaji po kupcima', group: 'Izveštaji' },
  { key: 'report-stock', label: 'Izveštaj o zalihama', group: 'Izveštaji' },
  { key: 'report-expenses', label: 'Evidencija troškova', group: 'Izveštaji' },
  { key: 'report-profit', label: 'Profit po artiklu', group: 'Izveštaji' },
  { key: 'report-shop-profit', label: 'Zarada prodavnice', group: 'Izveštaji' },
  { key: 'report-insights', label: 'Predlozi za unapređenje', group: 'Izveštaji' },
  { key: 'report-writeoff', label: 'Otpisi', group: 'Izveštaji' },
  { key: 'report-filter', label: 'Filter report', group: 'Izveštaji' },
  { key: 'accounting-export', label: 'Knjigovodstvo eksport', group: 'Izveštaji' },
  { key: 'admin-operational-costs', label: 'Operativni troškovi', group: 'Izveštaji' },
  { key: 'admin-cost-definitions', label: 'Definicije troškova', group: 'Izveštaji' },
  { key: 'restaurant-tables', label: 'Stolovi', group: 'Restoran' },
  { key: 'restaurant-kitchen', label: 'Kuhinja (KDS)', group: 'Restoran' },
  { key: 'restaurant-reservations', label: 'Rezervacije', group: 'Restoran' },
  { key: 'restaurant-daily-menu', label: "Dnevni meni & 86'd", group: 'Restoran' },
  { key: 'restaurant-qr-orders', label: 'QR Narudžbe', group: 'Restoran' },
  { key: 'restaurant-arrivals', label: 'Dolasci', group: 'Restoran' },
  { key: 'restaurant-online-payments', label: 'Online uplate', group: 'Restoran' },
  { key: 'restaurant-guest-app', label: 'Guest aplikacija', group: 'Restoran' },
  { key: 'restaurant-venue-profile', label: 'Profil objekta', group: 'Restoran' },
  { key: 'restaurant-reservation-rules', label: 'Pravila rezervacija i cene', group: 'Restoran' },
  { key: 'restaurant-delivery', label: 'Dostava', group: 'Restoran' },
  { key: 'restaurant-unpaid', label: 'Dugovanja', group: 'Restoran' },
  { key: 'restaurant-food-cost', label: 'Food Cost', group: 'Restoran' },
  { key: 'restaurant-floor-editor', label: 'Raspored stolova', group: 'Restoran' },
  { key: 'restaurant-reports', label: 'Restoran izveštaji', group: 'Restoran' },
  { key: 'einvoice-outgoing', label: 'Izlazne fakture', group: 'Dokumenti i fakture' },
  { key: 'einvoice-incoming', label: 'Ulazne fakture', group: 'Dokumenti i fakture' },
  { key: 'einvoice-individual', label: 'Pojedinačna evidencija', group: 'Dokumenti i fakture' },
  { key: 'einvoice-summary', label: 'Zbirna evidencija', group: 'Dokumenti i fakture' },
  { key: 'einvoice-previous', label: 'Evidencija prethodnog prometa', group: 'Dokumenti i fakture' },
  { key: 'einvoice-credit', label: 'Knjižna odobrenja', group: 'Dokumenti i fakture' },
  { key: 'eotpremnica-outgoing', label: 'Izlazne otpremnice', group: 'Dokumenti i fakture' },
  { key: 'eotpremnica-incoming', label: 'Ulazne otpremnice', group: 'Dokumenti i fakture' },
  { key: 'admin-compensations', label: 'Kompenzacije', group: 'Dokumenti i fakture' },
  { key: 'admin-bank', label: 'Banka i uplate', group: 'Dokumenti i fakture' },
  { key: 'lpfr', label: 'L-PFR uređaji', group: 'Dokumenti i fakture' },
  { key: 'admin-articles', label: 'Artikli', group: 'Katalog artikala' },
  { key: 'admin-categories', label: 'Kategorije', group: 'Katalog artikala' },
  { key: 'admin-recipes', label: 'Normativi', group: 'Katalog artikala' },
  { key: 'admin-units', label: 'Jedinice mere', group: 'Katalog artikala' },
  { key: 'price-leveling', label: 'Nivelacija', group: 'Katalog artikala' },
  { key: 'calculations', label: 'Kalkulacije', group: 'Katalog artikala' },
  { key: 'price-history', label: 'Istorija cena', group: 'Katalog artikala' },
  { key: 'labels', label: 'Nalepnice cena', group: 'Katalog artikala' },
  { key: 'admin-customers', label: 'Kupci', group: 'Kupci i dobavljači' },
  { key: 'admin-suppliers', label: 'Dobavljači', group: 'Kupci i dobavljači' },
  { key: 'crm-guests', label: 'Gosti', group: 'Kupci i dobavljači' },
  { key: 'crm-loyalty', label: 'Loyalty podešavanja', group: 'Kupci i dobavljači' },
  { key: 'admin-discounts', label: 'Popusti', group: 'Popusti i nagrade' },
  { key: 'admin-vouchers', label: 'Vaucheri', group: 'Popusti i nagrade' },
  { key: 'admin-campaigns', label: 'Kampanje', group: 'Popusti i nagrade' },
  { key: 'admin-discount-audit', label: 'Audit popusta', group: 'Popusti i nagrade' },
  { key: 'admin-referral', label: 'Preporuke (Referal program)', group: 'Popusti i nagrade' },
  { key: 'partner-offers', label: 'Partnerske ponude', group: 'Popusti i nagrade' },
  { key: 'admin-operators', label: 'Operateri', group: 'Zaposleni' },
  { key: 'admin-operator-shifts', label: 'Smene operatera', group: 'Zaposleni' },
  { key: 'admin-operator-audit', label: 'Audit operatera', group: 'Zaposleni' },
  { key: 'warehouse-stock', label: 'Stanje zaliha', group: 'Magacin' },
  { key: 'warehouse-warehouses', label: 'Magacini', group: 'Magacin' },
  { key: 'warehouse-receiving', label: 'Prijem robe', group: 'Magacin' },
  { key: 'warehouse-dispatch', label: 'Otprema robe', group: 'Magacin' },
  { key: 'warehouse-transfer', label: 'Međumagacinski prenos', group: 'Magacin' },
  { key: 'warehouse-adjustment', label: 'Korekcija zaliha', group: 'Magacin' },
  { key: 'warehouse-inventory', label: 'Popis robe', group: 'Magacin' },
  { key: 'warehouse-writeoff', label: 'Otpis robe', group: 'Magacin' },
  { key: 'warehouse-incoming-receipts', label: 'Ulazni računi', group: 'Magacin' },
  { key: 'settings', label: 'Podešavanja', group: 'Sistem i podrška' },
  { key: 'invoice-numbering', label: 'Šabloni brojeva', group: 'Sistem i podrška' },
  { key: 'billing', label: 'Računi za licence', group: 'Sistem i podrška' },
  { key: 'support-tickets', label: 'Prijave problema', group: 'Sistem i podrška' },
];

/** Kljucevi koji se ne biraju u panelu - uvek su vidljivi. */
export const NAV_ALWAYS_VISIBLE = ['legal'] as const;

export const NAV_GROUPS: string[] = [...new Set(NAV_CATALOG.map((i) => i.group))];
